module.exports = __webpack_public_path__ + "img/ojo-cerrado.ec1132b5.svg";